module.exports = __webpack_public_path__ + "img/image2.5f911e02.png";